import memoizeOne from 'memoize-one';

export interface EnvVars {
    apiV2Url: string;
    env: string;
    adminLegacyUrl: string;
    adminV2Url: string;
    auth0Domain: string;
    auth0ClientId: string;
    auth0Audience: string;
}

export const getEnvVariables = (): EnvVars => {
    const result: EnvVars = {
        apiV2Url: process.env.REACT_APP_API_URL!,
        env: process.env.REACT_APP_CLOUD_ENV!,
        adminLegacyUrl: process.env.REACT_APP_LEGACY_ADMIN_URL!,
        adminV2Url: process.env.REACT_APP_V2_ADMIN_URL!,
        auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN!,
        auth0ClientId: process.env.REACT_APP_AUTH0_CLIENT_ID!,
        auth0Audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
    };

    try {
        const windowObj = window as any;
        result.apiV2Url =
            windowObj && windowObj.REACT_APP_API_URL
                ? windowObj.REACT_APP_API_URL
                : process.env.REACT_APP_API_URL;
        result.env =
            windowObj && windowObj.REACT_APP_CLOUD_ENV
                ? windowObj.REACT_APP_CLOUD_ENV
                : process.env.REACT_APP_CLOUD_ENV;
        result.adminLegacyUrl =
            windowObj && windowObj.REACT_APP_LEGACY_ADMIN_URL
                ? windowObj.REACT_APP_LEGACY_ADMIN_URL
                : process.env.REACT_APP_LEGACY_ADMIN_URL;
        result.adminV2Url =
            windowObj && windowObj.REACT_APP_V2_ADMIN_URL
                ? windowObj.REACT_APP_V2_ADMIN_URL
                : process.env.REACT_APP_V2_ADMIN_URL;
        result.auth0Domain =
            windowObj && windowObj.REACT_APP_AUTH0_DOMAIN
                ? windowObj.REACT_APP_AUTH0_DOMAIN
                : process.env.REACT_APP_AUTH0_DOMAIN;
        result.auth0ClientId =
            windowObj && windowObj.REACT_APP_AUTH0_CLIENT_ID
                ? windowObj.REACT_APP_AUTH0_CLIENT_ID
                : process.env.REACT_APP_AUTH0_CLIENT_ID;
        result.auth0Audience =
            windowObj && windowObj.REACT_APP_AUTH0_AUDIENCE
                ? windowObj.REACT_APP_AUTH0_AUDIENCE
                : process.env.REACT_APP_AUTH0_AUDIENCE;

        return result;
    } catch {
        return result;
    }
};

export default memoizeOne(getEnvVariables);
